import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toastIfError } from '../../../utils/toast';
import { EmvioCheckbox, EmvioValidatedForm, EmvioValidatedButton, EmvioValidatedInput } from '@nexio/emvio-form-components';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { historyShape } from '../../../utils/propTypes';
import _ from 'lodash';
import './PricingAgreement.scss';
import { acceptPricing, fetchMerchantLegalInformation } from '../accountAgreementActions';
import {
    getIsPricingAgreementAcceptLoading,
    getIsPricingAgreementAccepted,
    getNexioPricingError,
    getMerchantLegalInformation
} from '../accountAgreementEntity';
import { getSelf as fetchSelf } from '../../Self/selfActions';
import { getSelf } from '../../Self/selfEntity';
import { getBank as fetchBank } from '../../Bank/bankActions';
import { getBank } from '../../Bank/bankEntity';
import { getCostSchedule as fetchCostSchedule } from '../../Billing/billingActions';
import { getCostSchedule } from '../../Billing/billingEntity';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';
import moment from 'moment';
import { logout } from '../../Login/loginActions';
import { prettifyRate } from '../../../utils/string';

/* eslint-disable @stylistic/max-len */
const serviceTerms = ' Nexio is a payment management platform utilized to help the Customer facilitate payment and reduce risk from fraudulent transactions. Customer agrees to the terms and conditions of the Nexio Agreement and Nexio Pricing Agreement.';
const authTerms = ' Customer hereby authorizes Nexio to automatically withdraw fees owed in accordance with this Order Form, as applicable, from the Customer’s account at the financial institution (“Bank”) or Credit Card indicated herein or utilized by Customer in lieu of the Services. A payment that is not honored by Bank or Credit Card for any reason will be subject to additional fees as stated in your Nexio Agreement. This authorization shall remain in effect until Nexio has received written notice from the Merchant of its Termination.';
/* eslint-enable @stylistic/max-len */

export class PricingAgreement extends Component {
    static propTypes = {
        history: historyShape,
        updateUserError: PropTypes.string,
        isSubmitButtonLoading: PropTypes.bool,
        isPricingAgreementAcceptLoading: PropTypes.bool,
        onToggleModal: PropTypes.func,
        onAcceptPricingAgreement: PropTypes.func,
        user: PropTypes.any,
        bank: PropTypes.shape({
            bankName: PropTypes.string,
            bankRoutingNumber: PropTypes.string,
            bankAccountNumber: PropTypes.string
        }),
        costSchedule: PropTypes.any,
        isPricingAgreementAccepted: PropTypes.bool,
        nexioAgreementError: PropTypes.string,
        onGetSelf: PropTypes.func,
        onGetBank: PropTypes.func,
        onFetchCostSchedule: PropTypes.func,
        onFetchMerchantLegalInformation: PropTypes.func,
        merchantLegalInformation: PropTypes.any,
        merchantIds: PropTypes.arrayOf(PropTypes.string),
        onLogout: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            didAcceptTerms: false,
            billingContactFullName: this.props.user.billingContactFullName || '',
            billingContactPhone: this.props.user.billingContactPhone || '',
            billingContactEmail: this.props.user.billingContactEmail || '',
            businessLegalName: this.props.user.businessLegalName || '',
            address1: this.props.user.address1 || '',
            address2: this.props.user.address2 || '',
            city: this.props.user.city || '',
            state: this.props.user.state || '',
            postalCode: this.props.user.postalCode || '',
            country: this.props.user.country || '',
            bankName: '',
            bankRoutingNumber: '',
            bankAccountNumber: ''
        };

        this.submitButtonRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.user.accessRights.merchantIds) {
            this.props.onGetBank();
            this.props.onFetchCostSchedule();
            this.props.onFetchMerchantLegalInformation(Object.keys(this.props.user.accessRights.merchantIds));
        }
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'nexioAgreementError');
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isPricingAgreementAccepted') && this.props.isPricingAgreementAccepted) {
            toast('Nexio Pricing Agreement Accepted Successfully.', { type: 'success' });

            this.props.onGetSelf();
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'bank')) {
            this.setState({
                bankName: _.get(this.props.bank, 'bankName'),
                bankRoutingNumber: _.get(this.props.bank, 'bankRoutingNumber'),
                bankAccountNumber: _.get(this.props.bank, 'bankAccountNumber')
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const {
            billingContactFullName,
            billingContactPhone,
            billingContactEmail,
            businessLegalName,
            address1,
            address2,
            city,
            state,
            postalCode,
            country,
            bankName,
            bankRoutingNumber,
            bankAccountNumber
        } = this.state;

        this.props.onAcceptPricingAgreement({
            agreementType: 'NEXIO_PRICING',
            billingContactFullName,
            billingContactPhone,
            billingContactEmail,
            businessLegalName,
            address1,
            address2,
            city,
            state,
            postalCode,
            country,
            bankName,
            bankRoutingNumber,
            bankAccountNumber
        });
    };

    handleAcceptNexioAgreement = () => {
        this.setState({ didAcceptTerms: !this.state.didAcceptTerms });
    };

    handleClick = () => {
        this.props.onLogout();
    };

    renderPricing = () => {
        if (this.props.costSchedule && this.props.merchantLegalInformation) {
            const accountCostSchedule = _.get(this.props, 'costSchedule.account.costSchedule') || {};
            const merchantCostSchedules = _.get(this.props, 'costSchedule.merchants') || {};
            const merchantInformation = _.get(this.props, 'merchantLegalInformation');

            let accountFees = _.reduce(accountCostSchedule, (acc, info, name) => {
                for (let i = 0; i < info.length; i++) {
                    let lastMonth = 'Ongoing';

                    let found = false;
                    let j = 1;

                    while (!found) {
                        if (info[i + j]) {
                            if (info[i + j].startDate !== info[i].startDate) {
                                lastMonth = moment(info[i + j].startDate).subtract(1, 'month').format('YYYY/MM');
                                found = true;
                            } else {
                                j++;
                            }
                        } else {
                            found = true;
                        }
                    }

                    acc.push({ ...info[i], name, lastMonth });
                }

                return acc;
            }, []);

            accountFees = _.sortBy(accountFees, ['name', 'startDate']);

            return (
                <div className="agreement-body">
                    <div className="agreement-section signer-info">
                        <span>Date: {moment().format('MM/DD/YYYY')}</span>
                        <span>Signer: {this.props.user.firstName} {this.props.user.lastName}</span>
                        <span>Email: {this.props.user.userName}</span>
                        <span>{this.props.user.phone ? `Phone: ${this.props.user.phone}` : null}</span>
                    </div>
                    {this.renderBillingInfo()}
                    {this.renderMerchantLegalInfo(merchantInformation)}
                    <div className="agreement-section service-text">
                        <u>Service(s):</u>
                        {serviceTerms}
                    </div>
                    <div className="agreement-section account-pricing">
                        <div className="account-pricing-row">
                            <div className="fee-name">Account Fees</div>
                            <div className="fee-class">Fee Class</div>
                            <div className="amount">Amount</div>
                            <div className="start-month">Start Month</div>
                            <div className="end-month">End Month</div>
                        </div>
                        {
                            _.map(accountFees, (feeInfo) => {
                                return (
                                    <div className="account-pricing-row">
                                        <div>{feeInfo.name}</div>
                                        <div>{feeInfo.feeClass}</div>
                                        <div>{prettifyRate(feeInfo.rate)}</div>
                                        <div>{feeInfo.startDate}</div>
                                        <div>{feeInfo.lastMonth}</div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    {this.renderMerchantPricingInfo(merchantCostSchedules)}
                    <div className="agreement-section authorization-text">
                        <u>Authorization for Automatic Withdrawal of Fees.</u>
                        {authTerms}
                    </div>
                    <div className="agreement-section authorization-text">
                        Please contact us by email at <a href="mailto: support@nex.io">support@nex.io</a> or call 1-877-267-4324 with any questions regarding this Nexio Pricing Agreement.
                    </div>
                </div>
            );
        }
    };

    renderMerchantLegalInfo(merchantLegalInformation) {
        const mliMap = merchantLegalInformation.map((merchant) => {
            return (
                <div key={merchant.merchantId} className="legal-info">
                    <div className="merchant-id merchant-legal-address-row">
                        <div className="field-label">Merchant ID</div>
                        <div className="field-value">{_.get(merchant, 'merchantId')}</div>
                    </div>
                    <div className="merchant-dbaname merchant-legal-address-row">
                        <div className="field-label">DBA Name</div>
                        <div className="field-value">{_.get(merchant, 'dbaName')}</div>
                    </div>
                    <div className="merchant-legal-name merchant-legal-address-row">
                        <div className="field-label">Legal Name</div>
                        <div className="field-value">{_.trim(_.get(merchant, 'legalName'))}</div>
                    </div>
                    <div className="merchant-legal-address merchant-legal-address-row">
                        <div className="field-label">Legal Address</div>
                        <div className="field-value">{_.replace(merchant.address, ', ', '\n')}</div>
                    </div>
                </div >
            );
        });

        return (<div className="agreement-section legal-address">
            <div className="legal-info merchant-legal-info-header">
                <div className="merchant-legal-address-row merchant-id">
                    Merchant ID
                </div>
                <div className="merchant-legal-address-row merchant-dbaname">
                    DBA Name
                </div>
                <div className="merchant-legal-address-row merchant-legal-name">
                    Legal Name
                </div>
                <div className="merchant-legal-address-row merchant-legal-address">
                    Legal Address
                </div>
            </div>
            {mliMap}
        </div>);
    }

    renderMerchantPricingInfo(merchantCostSchedules) {
        if (_.isEmpty(merchantCostSchedules)) {
            return;
        }

        return _.map(merchantCostSchedules, (fees, merchantId) => {
            let merchantFeeInfo = _.reduce(fees.costSchedule, (acc, info, name) => {
                for (let i = 0; i < info.length; i++) {
                    let lastMonth = 'Ongoing';

                    let found = false;
                    let j = 1;

                    while (!found) {
                        if (info[i + j]) {
                            if (info[i + j].startDate !== info[i].startDate) {
                                lastMonth = moment(info[i + j].startDate).subtract(1, 'month').format('YYYY/MM');
                                found = true;
                            } else {
                                j++;
                            }
                        } else {
                            found = true;
                        }
                    }

                    acc.push({ ...info[i], lastMonth, name });
                }

                return acc;
            }, []);

            merchantFeeInfo = _.sortBy(merchantFeeInfo, ['name', 'startDate', 'floor']);

            return (
                <div className="agreement-section merchant-pricing">
                    <div className="merchant-fees-row">
                        <div>MID Fees ({merchantId})</div>
                        <div>Fee Class</div>
                        <div>Amount</div>
                        <div>Start Month</div>
                        <div>End Month</div>
                        <div>Tier Floor</div>
                    </div>
                    {_.map(merchantFeeInfo, (feeInfo) => {
                        return (
                            <div className="merchant-fees-row">
                                <div>{feeInfo.name}</div>
                                <div>{feeInfo.feeClass}</div>
                                <div>{prettifyRate(feeInfo.rate)}</div>
                                <div>{feeInfo.startDate}</div>
                                <div>{feeInfo.lastMonth}</div>
                                <div>{_.isNull(feeInfo.floor) ? '' : feeInfo.floor.toLocaleString()}</div>
                            </div>
                        );
                    })}
                </div>
            );
        });
    }

    renderBillingInfo = () => {

        const {
            billingContactFullName,
            billingContactPhone,
            billingContactEmail,
            businessLegalName,
            address1,
            address2,
            city,
            state,
            postalCode,
            country,
            bankName,
            bankRoutingNumber,
            bankAccountNumber
        } = this.state;

        return (
            <div className="agreement-section account-billing-info">
                <div className="field-label">Billing Info</div>
                <div className="billing-input">
                    <p>Billing Contact</p>
                    <EmvioValidatedInput
                        className="full-name-input"
                        labelText="Full Name"
                        name="Full Name"
                        onChange={(e) => this.setState({ billingContactFullName: e.target.value })}
                        type="text"
                        value={billingContactFullName}
                        shouldNotTrim={true}
                        validations={['required']}
                    />
                    <div className="two-input">
                        <EmvioValidatedInput
                            className="phone-input"
                            labelText="Phone Number"
                            name="Phone Number"
                            onChange={(e) => this.setState({ billingContactPhone: e.target.value })}
                            type="text"
                            value={billingContactPhone}
                            shouldEnforcePhone={true}
                            validations={['required']}
                        />
                        <EmvioValidatedInput
                            className="email-input"
                            labelText="Email"
                            name="Email"
                            onChange={(e) => this.setState({ billingContactEmail: e.target.value })}
                            type="text"
                            value={billingContactEmail}
                            validations={['email', 'required']}
                        />
                    </div>
                    <p>Business Legal Address</p>
                    <EmvioValidatedInput
                        className="legal-business-name-input"
                        labelText="Legal Business Name"
                        name="Legal Business Name"
                        onChange={(e) => this.setState({ businessLegalName: e.target.value })}
                        type="text"
                        value={businessLegalName}
                        shouldNotTrim={true}
                        validations={['required']}
                    />
                    <div className="two-input">
                        <EmvioValidatedInput
                            className="address-1-input"
                            labelText="Address 1"
                            name="Address 1"
                            onChange={(e) => this.setState({ address1: e.target.value })}
                            type="text"
                            value={address1}
                            shouldNotTrim={true}
                            validations={['required']}
                        />
                        <EmvioValidatedInput
                            className="address-2-input"
                            labelText="Address 2"
                            name="Address 2"
                            onChange={(e) => this.setState({ address2: e.target.value })}
                            type="text"
                            value={address2}
                            shouldNotTrim={true}
                        />
                    </div>
                    <div className="two-input">
                        <EmvioValidatedInput
                            className="city-input"
                            labelText="City"
                            name="City"
                            onChange={(e) => this.setState({ city: e.target.value })}
                            type="text"
                            value={city}
                            shouldNotTrim={true}
                            validations={['required']}
                        />
                        <EmvioValidatedInput
                            className="state-input"
                            labelText="State"
                            name="State"
                            onChange={(e) => this.setState({ state: e.target.value })}
                            type="text"
                            value={state}
                            shouldNotTrim={true}
                            validations={['required']}
                        />
                    </div>
                    <div className="two-input">
                        <EmvioValidatedInput
                            className="postal-code-input"
                            labelText="Postal Code"
                            name="Postal Code"
                            onChange={(e) => this.setState({ postalCode: e.target.value })}
                            type="text"
                            value={postalCode}
                            validations={['required']}
                        />
                        <EmvioValidatedInput
                            className="country-input"
                            labelText="Country"
                            name="Country"
                            onChange={(e) => this.setState({ country: e.target.value })}
                            type="text"
                            value={country}
                            shouldNotTrim={true}
                            validations={['required']}
                        />
                    </div>
                    <p>Banking Details</p>
                    <EmvioValidatedInput
                        className="bank-name-input"
                        labelText="Bank Name"
                        name="Bank Name"
                        onChange={(e) => this.setState({ bankName: e.target.value })}
                        type="text"
                        value={bankName}
                        shouldNotTrim={true}
                        validations={['required']}
                    />
                    <div className="two-input">
                        <EmvioValidatedInput
                            className="bank-account-input"
                            labelText="Bank Account Number"
                            name="Bank Account Number"
                            onChange={(e) => this.setState({ bankAccountNumber: e.target.value })}
                            type="text"
                            value={bankAccountNumber}
                            validations={['required']}
                        />
                        <EmvioValidatedInput
                            className="bank-routing-input"
                            labelText="Bank Routing Number"
                            name="Bank Routing Number"
                            onChange={(e) => this.setState({ bankRoutingNumber: e.target.value })}
                            type="text"
                            value={bankRoutingNumber}
                            shouldEnforceInt={true}
                            validations={['required']}
                        />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        if (this.props.costSchedule && this.props.merchantLegalInformation) {
            return (
                <div className="emvio-pricing-agreement">
                    <div className="agreement">
                        <div className="agreement-header">
                            Nexio Pricing Agreement
                            <span className="logout" onClick={this.handleClick}> Logout</span>
                        </div>
                        <EmvioValidatedForm className="agreement-form"
                            onSubmit={this.handleSubmit}
                            getButtonRef={() => this.submitButtonRef.current}
                            hasExternalErrors={(!this.state.didAcceptTerms)}>
                            {this.renderPricing()}
                            <div className="agreement-footer">
                                <div className="agreement-submit">
                                    <div className="agree-checkbox">
                                        <EmvioCheckbox
                                            validations={['required']}
                                            checked={this.state.didAcceptTerms}
                                            onChange={this.handleAcceptNexioAgreement}
                                        />
                                        <div className="label" onClick={this.handleAcceptNexioAgreement}>I have read and agree to the Nexio Pricing Agreement</div>
                                    </div>
                                    <EmvioValidatedButton className="submit-button"
                                        ref={this.submitButtonRef}
                                        shouldNotValidate={true}
                                        isLoading={this.props.isPricingAgreementAcceptLoading}
                                    >
                                        Submit
                                    </EmvioValidatedButton>
                                </div>
                            </div>
                        </EmvioValidatedForm>
                    </div>
                </div>
            );
        } else {
            return (
                <LoadingSpinner relative />
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        isPricingAgreementAccepted: getIsPricingAgreementAccepted(state),
        nexioAgreementError: getNexioPricingError(state),
        user: getSelf(state),
        bank: getBank(state),
        costSchedule: getCostSchedule(state),
        merchantLegalInformation: getMerchantLegalInformation(state),
        isPricingAgreementAcceptLoading: getIsPricingAgreementAcceptLoading(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onFetchCostSchedule: () => dispatch(fetchCostSchedule()),
        onAcceptPricingAgreement: (agreementType) => dispatch(acceptPricing(agreementType)),
        onGetSelf: () => dispatch(fetchSelf()),
        onGetBank: () => dispatch(fetchBank()),
        onFetchMerchantLegalInformation: (merchantIds) => dispatch(fetchMerchantLegalInformation(merchantIds)),
        onLogout: () => dispatch(logout())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PricingAgreement));
